import { render, staticRenderFns } from "./file-history.vue?vue&type=template&id=de3f9b26&scoped=true"
import script from "./file-history.vue?vue&type=script&lang=js"
export * from "./file-history.vue?vue&type=script&lang=js"
import style0 from "./file-history.vue?vue&type=style&index=0&id=de3f9b26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de3f9b26",
  null
  
)

export default component.exports